var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"card-icon",attrs:{"src":require("@/app/assets/images/card-brand/Interpayment.png"),"alt":"Inter payment"}})}
var staticRenderFns = []

export { render, staticRenderFns }